import React from 'react'

import { WithObjects } from './WithObjectsComponent'

export const withObjects = (Child) => (props) => (
    <WithObjects>{(objProps) => <Child {...objProps} {...props} />}</WithObjects>
)
